module.exports = __webpack_public_path__ + "img/withdraw-bg.b3325804.png";